// @ts-nocheck

import { isIOSEmbeddedAndStandalone } from '../client';
import { osMajorVersion } from '../lib/useragent';

export const isBetshareEnabled = !(isIOSEmbeddedAndStandalone && osMajorVersion !== null && osMajorVersion <= 8);
